import { useDraggable } from '@dnd-kit/core';
import { ReactNode } from 'react';
import { DragItem } from '../state';

interface Props {
  id: string;
  data: DragItem;
  children: ReactNode;
}

export function DraggableRow({ id, data, children }: Props) {
  const { setNodeRef, listeners } = useDraggable({ id, data });

  return (
    <div ref={setNodeRef} {...listeners} className="cursor-grab">
      {children}
    </div>
  );
}

export default DraggableRow;
